import CryptoJS from "crypto-js";

var key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_KEY);
var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_IV);

export function encryption(request, isStringify) {
    var request_ = isStringify ? JSON.stringify(request) : request;
    var encrypted = CryptoJS.AES.encrypt(request_, key, { iv: iv });
    return encrypted.toString();
}

export function decryption(request) {
    var decrypted = CryptoJS.AES.decrypt(request.toString(), key, { iv: iv });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}
